import React from "react";

import { Button, Box } from "@mui/material";

import PageTopMessage from "components/shared/PageTopMessage";

import { App } from "views/MyApps/App";

export function ReadApps(props) {
  return (
    <React.Fragment>
      <PageTopMessage messageState={props.messageState} />
      {props.apps.map((app) => (
        <App
          app={app}
          key={app.id}
          handleDeletion={props.handleDeletion}
          applicationType={app.application_type}
        />
      ))}

      <Box mt={2}>
        <Button
          onClick={() => props.setCrudState("create")}
          color="primary"
          variant="contained"
        >
          Register new app
        </Button>
      </Box>
    </React.Fragment>
  );
}
